module.exports = __webpack_public_path__ + "static/presidents-message-cb18219d825352e05e8d2f4180e8ff8f.jpg";